import React from 'react';

import { useTranslation, Trans } from "react-i18next";

import d1 from '../../img/CompositeMesh/whycomp/d1.svg';
import d2 from '../../img/CompositeMesh/whycomp/d2.svg';
import d3 from '../../img/CompositeMesh/whycomp/d3.svg';
import d4 from '../../img/CompositeMesh/whycomp/d4.svg';
import d5 from '../../img/CompositeMesh/whycomp/d5.svg';
import d6 from '../../img/CompositeMesh/whycomp/d6.svg';
import d7 from '../../img/CompositeMesh/whycomp/d7.svg';
import d8 from '../../img/CompositeMesh/whycomp/d8.svg';
import d9 from '../../img/CompositeMesh/whycomp/d9.svg';
import d10 from '../../img/CompositeMesh/whycomp/d10.svg';
import d11 from '../../img/CompositeMesh/whycomp/d11.svg';
import d12 from '../../img/CompositeMesh/whycomp/d12.svg';
import d13 from '../../img/CompositeMesh/whycomp/d13.svg';
import d14 from '../../img/CompositeMesh/whycomp/d14.svg';
import d15 from '../../img/CompositeMesh/whycomp/d15.svg';

function WhyComposite () {

    const { t } = useTranslation();
      
    return(
        <div className="bg-[#1D1D1D] pt-[100px] xl:pt-[200px]">
            <div className="max-w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto relative">
                <div className="flex items-center justify-center">
                    <p className="text-[28px] xl:text-[45px] open-sans text-[#F26522] text-center leading-[1.4]">
                        <Trans>{t("compositerein.add.27")}</Trans>
                    </p>
                </div>
                <div className='mt-[30px] xl:mt-[70px] w-full overflow-x-auto'>
                    <table className="border-separate border-spacing-y-[4px] relative min-w-[800px] xl:w-full">
                        <thead className="bg-[#F26522] open-sans text-[#1D1D1D] text-[12px] xl:text-[20px]">
                            <tr>
                                <th className="p-[15px] font-[600] md:font-[300]">
           
                                </th>
                                <th className="p-[15px] font-[600] md:font-[300]">
                                    {t("mansorymesh.11")}
                                </th>
                                <th className="p-[15px] font-[600] md:font-[300]">
                                    {t("mansorymesh.10")}
                                </th>
                            </tr>
                        </thead>
                        <tbody className="">
                            <tr>
                                <td className="p-[8px] md:p-[15px] text-[12px] md:text-[16px] text-[#F6F6F6] font-[300] open-sans bg-[#272727]">
                                    <p>{t('compositerein.add.28')}</p>
                                </td>
                                <td className="p-[8px] md:p-[15px] text-[12px] md:text-[16px] text-[#F6F6F6] font-[300] open-sans bg-[#272727]">
                                    <div className="flex flex-col items-center justify-center gap-2">
                                        <img src={d1} alt="" />
                                        <p>{t('compositerein.add.29')}</p>
                                    </div>
                                </td>
                                <td className="p-[8px] md:p-[15px] text-[12px] md:text-[16px] text-[#F6F6F6] font-[300] open-sans bg-[#272727]">
                                    <div className="flex flex-col items-center justify-center gap-2">
                                        <img src={d2} alt="" />
                                        <p>{t('compositerein.add.30')}</p>
                                    </div>
                                </td>
                            </tr>     
                            <tr>
                                <td className="p-[8px] md:p-[15px] text-[12px] md:text-[16px] text-[#F6F6F6] font-[300] open-sans bg-[#272727]">
                                    <p>{t('compositerein.add.31')}</p>
                                </td>
                                <td className="p-[8px] md:p-[15px] text-[12px] md:text-[16px] text-[#F6F6F6] font-[300] open-sans bg-[#272727]">
                                    <div className="flex flex-col items-center justify-center gap-2">
                                        <img src={d3} alt="" />
                                        <p>{t('compositerein.add.32')}</p>
                                    </div>
                                </td>
                                <td className="p-[8px] md:p-[15px] text-[12px] md:text-[16px] text-[#F6F6F6] font-[300] open-sans bg-[#272727]">
                                    <div className="flex flex-col items-center justify-center gap-2">
                                        <img src={d4} alt="" />
                                        <p>{t('compositerein.add.33')}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-[8px] md:p-[15px] text-[12px] md:text-[16px] text-[#F6F6F6] font-[300] open-sans bg-[#272727]">
                                    <p>{t('compositerein.add.34')}</p>
                                </td>
                                <td className="p-[8px] md:p-[15px] text-[12px] md:text-[16px] text-[#F6F6F6] font-[300] open-sans bg-[#272727]">
                                    <div className="flex flex-col items-center justify-center gap-2">
                                        <img src={d5} alt="" />
                                        <p className='text-center'><Trans>{t('compositerein.add.35')}</Trans></p>
                                    </div>
                                </td>
                                <td className="p-[8px] md:p-[15px] text-[12px] md:text-[16px] text-[#F6F6F6] font-[300] open-sans bg-[#272727]">
                                    <div className="flex flex-col items-center justify-center gap-2">
                                        <img src={d6} alt="" />
                                        <p className='text-center'><Trans>{t('compositerein.add.36')}</Trans></p>
                                    </div>
                                </td>
                            </tr>     
                            <tr>
                                <td className="p-[8px] md:p-[15px] text-[12px] md:text-[16px] text-[#F6F6F6] font-[300] open-sans bg-[#272727]">
                                    <p>{t('compositerein.add.37')}</p>
                                </td>
                                <td className="p-[8px] md:p-[15px] text-[12px] md:text-[16px] text-[#F6F6F6] font-[300] open-sans bg-[#272727]">
                                    <div className="flex flex-col items-center justify-center gap-2">
                                        <img src={d7} alt="" />
                                        <p className='text-center'><Trans>{t('compositerein.add.38')}</Trans></p>
                                    </div>
                                </td>
                                <td className="p-[8px] md:p-[15px] text-[12px] md:text-[16px] text-[#F6F6F6] font-[300] open-sans bg-[#272727]">
                                    <div className="flex flex-col items-center justify-center gap-2">
                                        <img src={d8} alt="" />
                                        <p className='text-center'><Trans>{t('compositerein.add.39')}</Trans></p>
                                    </div>
                                </td>
                            </tr>   
                            <tr>
                                <td className="p-[8px] md:p-[15px] text-[12px] md:text-[16px] text-[#F6F6F6] font-[300] open-sans bg-[#272727]">
                                    <p>{t('compositerein.add.40')}</p>
                                </td>
                                <td className="p-[8px] md:p-[15px] text-[12px] md:text-[16px] text-[#F6F6F6] font-[300] open-sans bg-[#272727]">
                                    <div className='flex flex-col items-center'>
                                        <div className='flex gap-[60px]'>
                                            <div className="flex flex-col items-center justify-center gap-2">
                                                <img src={d9} alt="" />
                                                <p className='text-center'><Trans>{t('compositerein.add.41')}</Trans></p>
                                            </div>
                                            <div className="flex flex-col items-center justify-center gap-2">
                                                <img src={d10} alt="" />
                                                <p className='text-center'><Trans>{t('compositerein.add.42')}</Trans></p>
                                            </div>
                                        </div>
                                        <div className='flex gap-[60px] mt-[30px]'>
                                            <div className="flex flex-col items-center justify-center gap-2">
                                                <img src={d11} alt="" />
                                                <p className='text-center'><Trans>{t('compositerein.add.43')}</Trans></p>
                                            </div>
                                            <div className="flex flex-col items-center justify-center gap-2">
                                                <img src={d12} alt="" />
                                                <p className='text-center'><Trans>{t('compositerein.add.44')}</Trans></p>
                                            </div>
                                            <div className="flex flex-col items-center justify-center gap-2">
                                                <img src={d13} alt="" />
                                                <p className='text-center'><Trans>{t('compositerein.add.45')}</Trans></p>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td className="p-[8px] md:p-[15px] text-[12px] md:text-[16px] text-[#F6F6F6] font-[300] open-sans bg-[#272727]">
                                    <div className='flex gap-[60px]'>
                                        <div className="flex flex-col items-center justify-center gap-2">
                                            <img src={d14} alt="" />
                                            <p className='text-center'><Trans>{t('compositerein.add.46')}</Trans></p>
                                        </div>
                                        <div className="flex flex-col items-center justify-center gap-2">
                                            <img src={d15} alt="" />
                                            <p className='text-center'><Trans>{t('compositerein.add.47')}</Trans></p>
                                        </div>
                                    </div>
                                </td>
                            </tr>                                   
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default WhyComposite;